<template>
  <div class="layout">
    <page-header @SearchChange="SearchChange" />
    <div class="page-content">
      <article-list ref="al" />
    </div>
    <page-footer v-if="noMoreData" />
  </div>
</template>
<script>
import PageHeader from '@/components/header/PageHeader'
import PageFooter from '@/components/footer/PageFooter'
import Banners from './modules/Banners'
import ArticleList from './modules/ArticleList'
export default {
  name: 'Main',
  components: {
    PageHeader,
    PageFooter,
    Banners,
    ArticleList
  },
  data () {
    return {
      noMoreData: true,
      checkModuleFalg: false
    }
  },
  methods: {
    SearchChange (_key) {
      this.$refs.al.addKey(_key)
    }
  }
}
</script>
<style lang="less" scoped>
.layout {
  height: 100vh;
  .page-content {
    width: 1190px;
    min-width: 1190px;
    margin: 0;
    position: relative;
    margin: 0 auto;
  }
}
</style>